<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Utenti'
    }]"
  />
  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
      <SearchSelect
        v-model="disabledStatus"
        name="user-disabled-status"
        :options="{
          '1' : 'Bloccati',
          '0' : 'Attivi',
        }"
      />
      <CompanyFilterSelect
        v-model="companyUuid"
        name="user-disabled-status"
      />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="authStore.canManageUser"
        @click="router.push('/utenti/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Utente
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="email"
        >
          Email
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="firstname"
        >
          Nome
        </SortableColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="user in data"
        :key="'user-table-' + user.uuid"
        class="odd:bg-gray-100"
        :class="{ 'text-gray-300': user.disabled || user.companyDisabled }"
      >
        <td class="p-2">
          {{ user.email }}
        </td>
        <td class="p-2">
          {{ user.firstname }} {{ user.lastname }}
        </td>
        <td class="p-2">
          {{ user.cebisCode }}
        </td>
        <td
          class="p-2 text-right"
          :class="{ 'text-corepla-text': user.disabled || user.companyDisabled }"
        >
          <RouterLink
            v-if="authStore.canManageUser"
            title="Modifica Utente"
            :to="'/utenti/' + user.uuid"
          >
            <PencilSquareIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>

          <a
            v-if="authStore.canManageUser"
            href="#"
            title="Invia Reset Password"
            @click.prevent="resetPassword(user)"
          >
            <EnvelopeIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            v-if="!user.disabled && authStore.canManageUser"
            href="#"
            title="Blocca Utente"
            @click.prevent="block(user)"
          >
            <PauseCircleIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            v-if="user.disabled && authStore.canManageUser"
            href="#"
            title="Ripristina Utente"
            @click.prevent="unblock(user)"
          >
            <PlayCircleIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            v-if="authStore.canManageUser"
            href="#"
            title="Elimina Utente"
            @click.prevent="destroy(user)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  EnvelopeIcon,
  PauseCircleIcon,
  PencilSquareIcon,
  PlayCircleIcon,
  PlusCircleIcon,
  TrashIcon} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRoute,useRouter } from 'vue-router'

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import CompanyFilterSelect from "@/components/list/filters/CompanyFilterSelect.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SearchSelect from "@/components/list/SearchSelect.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const search = ref('')
const disabledStatus = ref(null);
const companyUuid = ref(null);

const sortStatus = ref(["email", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/auction-user/list",
  sortStatus,
  search,
  searchProperties: ['email', 'firstname', 'lastname'],
  extraFilter: (item) => {
    return (disabledStatus.value ? item.disabled == disabledStatus.value : true) && 
      (companyUuid.value ? item.companyUuid == companyUuid.value : true);
  }
})

watch(disabledStatus, () => {
  doFilter()
})

watch(companyUuid, () => {
  doFilter()
})

companyUuid.value = route.query.companyUuid;

const destroy = (user) => {
  action('delete', 'auction-user/' + user.uuid, 'Utente eliminato con successo')
}

const resetPassword = (user) => {
  action('get', 'auction-user/reset-password/' + user.uuid, 'E-Mail inviata con successo')
}

const block = (user) => {
  action('put', 'auction-user/block/' + user.uuid, 'Utente bloccato con successo')
}

const unblock = (user) => {
  action('put', 'auction-user/unblock/' + user.uuid, 'Utente ripristinato con successo')
}
</script>
